import { getProficiencyLabel } from "./assessmentHelpers";
import S from "./Assessments.module.scss";

/** Competency score column */
const CompetencyScore = ({
  latestScorePercent,
  latestTeamAveragePercent,
}: {
  latestScorePercent: number | null;
  latestTeamAveragePercent: number | null;
}) => {
  const label = getProficiencyLabel(latestScorePercent);

  return (
    <div className={S.competencyColumn}>
      <h4 className={S.competencyHeading}>
        <span className={S.competencyLabel}>Competency Score</span>
        {label && <span className="atlas-h3">{label}</span>}
      </h4>
      <div className={S.scoreRow}>
        {latestScorePercent != null && (
          <div>
            <span
              className={S.scoreValue}
              aria-label={`Your latest score: ${Math.round(latestScorePercent)} percent`}
            >
              {Math.round(latestScorePercent)}%
            </span>
            <div className={S.scoreLabel} aria-hidden="true">
              Your latest score
            </div>
          </div>
        )}
        {latestTeamAveragePercent != null && (
          <div>
            <span
              className={S.scoreValue}
              aria-label={`Latest team average: ${Math.round(latestTeamAveragePercent)} percent`}
            >
              {Math.round(latestTeamAveragePercent)}%
            </span>
            <div className={S.scoreLabel} aria-hidden="true">
              Latest team avg
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export { CompetencyScore };
